export const tagsListKey = () => ["tags-list"];

export const tagsListParamsKey = ({ queryParams }) => [...tagsListKey(), queryParams];
